import type Phaser from 'phaser';
import { TX, AUDIO } from '../registry/keys';
import { playSfx } from '../audio/sfx';

/** Bright party colors for confetti + fireworks. */
const COLORS = [0xff5a5a, 0xffd24a, 0x5ad06a, 0x5a9ad0, 0xd06ad0, 0xffffff];

/** A burst of colored confetti raining down the screen (screen-space, any scene). */
export function confetti(scene: Phaser.Scene, durationMs = 1400): void {
  const p = scene.add
    .particles(0, 0, TX.sparkle, {
      x: { min: 0, max: scene.scale.width },
      y: -10,
      lifespan: 2200,
      speedY: { min: 80, max: 210 },
      speedX: { min: -50, max: 50 },
      rotate: { min: 0, max: 360 },
      scale: { min: 0.7, max: 1.6 },
      quantity: 4,
      frequency: 28,
      tint: COLORS,
      duration: durationMs,
    })
    .setScrollFactor(0)
    .setDepth(9500);
  scene.time.delayedCall(durationMs + 2400, () => p.destroy());
}

/** A few timed firework bursts up in the sky. */
export function fireworks(scene: Phaser.Scene, n = 4): void {
  for (let i = 0; i < n; i++) {
    scene.time.delayedCall(i * 420 + Math.floor(Math.random() * 220), () => {
      const x = 40 + Math.random() * (scene.scale.width - 80);
      const y = 30 + Math.random() * scene.scale.height * 0.4;
      const b = scene.add
        .particles(x, y, TX.sparkle, {
          speed: { min: 40, max: 130 },
          angle: { min: 0, max: 360 },
          scale: { start: 1.7, end: 0 },
          lifespan: 700,
          quantity: 26,
          tint: COLORS[i % COLORS.length]!,
          emitting: false,
        })
        .setScrollFactor(0)
        .setDepth(9500);
      b.explode(26);
      playSfx(scene, AUDIO.pop);
      scene.time.delayedCall(950, () => b.destroy());
    });
  }
}

/** The full celebration — confetti always, plus fireworks for the big moments. */
export function celebrate(scene: Phaser.Scene, big = false): void {
  confetti(scene, big ? 2200 : 1100);
  if (big) fireworks(scene, 5);
}
